import createInstance from '../http';
import config from '@/const/config';
const { request } = createInstance(config.loginBaseUrl);

// https://91jkys.yuque.com/hnm3gl/ze8kgn/sa70ea
export default {
  // 账号密码登录
  userNameLogin: params => request.post(`/api/drugstore/1.0/pc_user_name_login`, {
    // 为kminghealth域名支持setCookie
    bizSource: 'B2B',
    ...params,
  }),
  // 获取验证码
  getVerifyCode: params => request.post(`/api/drugstore/1.0/send_verify_code`, params),
  // 验证码登录
  verifyCodeLogin: params => request.post(`/api/drugstore/1.0/pc_login`, {
    // 为kminghealth域名支持setCookie
    bizSource: 'B2B',
    ...params,
  }),
  // 绑定手机号
  bindMobile: params => request.post(`/api/drugstore/1.0/set_user_mobile`, params),
  // 修改密码
  changePassword: params => request.post(`/api/drugstore/1.0/change_password`, params),
  // 获取当前用户所有相关信息
  getUserInfo: params => request.get(`/api/app_portal/1.0.0/app-login-info`, { params }),
  // 查询销售人员信息
  querySalespersonInfo: params => request.get(`/api/share-mall-gateway-salesperson/1.0.0/querySalespersonInfo`, { params }),
  // 判断药城入口是否展示
  pcEntrance: params => request.get(`/api/app_portal/1.0.0/pc-drug-shop-entrance`, { params }),
  // 退出登录
  logout: () => request.post(`/api/drugstore/1.0/pc_logout`)
};
